import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { Link } from "react-router-dom";

export function WelcomeCard() {
  return (
    <Paper sx={{ p: 4, textAlign: "center" }}>
      <ChatBubbleOutlineIcon
        sx={{ fontSize: 48, color: "primary.main", mb: 2 }}
      />
      <Typography variant="h6" gutterBottom>
        Get started with Hanover Sales Coach
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          mb: 3,
          maxWidth: 480,
          mx: "auto"
        }}>
        Prepare for upcoming sales calls with AI-powered research, or upload
        call transcripts to get detailed performance analysis and coaching
        insights.
      </Typography>
      <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
        <Button variant="contained" component={Link} to="/chat">
          Start Your First Conversation
        </Button>
      </Box>
    </Paper>
  );
}
